import max from 'lodash-es/max';
import min from 'lodash-es/min';
import sum from 'lodash-es/sum';
import {
  ICPYDatum,
  ILoadable,
  IPYDatum,
  LoadableStatus,
  toNumericMap,
} from '../../Utils';
import {
  IAssignSectionOutput,
  IMergeOutput,
  INodeWithTrade,
} from './Utils';

export const merge = (
    assignOutputStatus: ILoadable<IAssignSectionOutput>,
    dataStatus: ILoadable<ICPYDatum[]>,
    worldTradeStatus: ILoadable<IPYDatum[]>,
  ): ILoadable<IMergeOutput> => {

  let result: ILoadable<IMergeOutput>;
  if (assignOutputStatus.status === LoadableStatus.Initial ||
      dataStatus.status === LoadableStatus.Initial ||
      worldTradeStatus.status === LoadableStatus.Initial) {

    result = {status: LoadableStatus.Initial};
  } else if (assignOutputStatus.status === LoadableStatus.Loading ||
      dataStatus.status === LoadableStatus.Loading ||
      worldTradeStatus.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (assignOutputStatus.status === LoadableStatus.NotPresent ||
      dataStatus.status === LoadableStatus.NotPresent ||
      worldTradeStatus.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {
      data: { nodeList, edgeList},
    } = assignOutputStatus;
    const {data: data} = dataStatus;
    const {data: worldTradeData} = worldTradeStatus;
    const dataMap = toNumericMap<ICPYDatum>(data, ({product_id}) => product_id);
    const worldTradeMap = toNumericMap<IPYDatum>(worldTradeData, ({product_id}) => product_id);

    const newNodeList: INodeWithTrade[] = [];
    const nodeListLength = nodeList.length;
    for (let i = 0; i < nodeListLength; i += 1) {
      const node = nodeList[i];
      const {id} = node;
      const retrievedData = dataMap.get(id);

      let rca: number, countryTrade: number;
      if (retrievedData === undefined) {
        // Sometimes it's possible to have no product data for a particular node
        // in the product space:
        rca = 0;
        countryTrade = 0;
      } else {
        const {export_rca, export_value} = retrievedData;
        rca = (export_rca === null) ? 0 : export_rca;
        countryTrade = export_value;
      }

      const retrievedWorldTradeDatum = worldTradeMap.get(id);
      if (retrievedWorldTradeDatum !== undefined) {
        const {export_value: worldTrade, pci} = retrievedWorldTradeDatum;
        // Product correspondiong to nodes in the product space network
        // always have a valid PCI.
        const toBeAdded: INodeWithTrade = {
          ...node,
          rca, countryTrade, worldTrade, pci,
        };
        newNodeList.push(toBeAdded);
      }
    }

    const allWorldTrades = newNodeList.map(({worldTrade}) => worldTrade);
    const allCountryTrades = newNodeList.map(({countryTrade}) => countryTrade);

    // Note: sum over all data points, just not those that have product space nodes:
    const total = sum(data.map(({export_value}) => export_value));

    result = {
      status: LoadableStatus.Present,
      data: {
        nodeList: newNodeList,
        edgeList,
        maxCountryTrade: max(allCountryTrades)!,
        minCountryTrade: min(allCountryTrades)!,
        maxWorldTrade: max(allWorldTrades)!,
        minWorldTrade: min(allWorldTrades)!,
        total,
      },
    };
  }
  return result;
};

export default merge;
